//src/store/actionTypes.ts
export enum ActionTypes {
  GLOBAL_ERROR = "GLOBAL_ERROR",

  AUTH_INITIALIZE = "@AUTH/AUTH_INITIALIZE",
  AUTH_LOGIN = "@AUTH/AUTH_LOGIN",
  AUTH_LOADING = "@AUTH/AUTH_LOADING",
  AUTH_ERROR = "@AUTH/AUTH_ERROR",
  SET_ACCESS_TOKEN = "@AUTH/SET_ACCESS_TOKEN",
  SET_USER_DATA = "@AUTH/SET_USER_DATA",

  SUPERVISOR_LOADING = "@SUPERVISOR/SUPERVISOR_LOADING",
  SUPERVISOR_ERROR = "@SUPERVISOR/SUPERVISOR_ERROR",
  GET_TICKETS = "@SUPERVISOR/GET_TICKETS",
  GET_TICKET_BY_ID = "@SUPERVISOR/GET_TICKET_BY_ID",
  GET_TECHNICIAN_GROUP_LIST = "@SUPERVISOR/GET_TECHNICIAN_GROUP_LIST",
  GET_TECHNICIAN_LIST = "@SUPERVISOR/GET_TECHNICIAN_LIST",
  GET_NINJAONE_BOARD_LIST = "@SUPERVISOR/GET_NINJAONE_BOARD_LIST",
  GET_NINJAONE_USERS = "@SUPERVISOR/GET_NINJAONE_USERS",
  REFRESH_TICKET_DATA = "@SUPERVISOR/REFRESH_TICKET_DATA",
  TICKET_REFRESHING = "@SUPERVISOR/TICKET_REFRESHING",

  CHAT_LOADING = "@CHAT/CHAT_LOADING",
  SET_THREAD_AUTOMATION = "@CHAT/SET_THREAD_AUTOMATION",
  CHAT_ERROR = "@CHAT/CHAT_ERROR",
  CREATE_TICKET_THREAD = "@CHAT/CREATE_TICKET_THREAD",
  GET_TICKET_THREAD = "@CHAT/GET_TICKET_THREAD",
  ADD_MESSAGE = "@CHAT/ADD_MESSAGE",
  UPDATE_MESSAGE_STATUS = "@CHAT/UPDATE_MESSAGE_STATUS",
  DROP_STREAMING_ASSISTANT = "@CHAT/DROP_STREAMING_ASSISTANT",
  REMOVE_PENDING_MESSAGE = "@CHAT/REMOVE_PENDING_MESSAGE",
  HUMAN_REVIEW_RESPONDED = "@CHAT/HUMAN_REVIEW_RESPONDED",
  FETCH_USER_THREADS_REQUEST = "@CHAT/FETCH_USER_THREADS_REQUEST",
  FETCH_USER_THREADS_SUCCESS = "@CHAT/FETCH_USER_THREADS_SUCCESS",
  FETCH_USER_THREADS_FAILURE = "@CHAT/FETCH_USER_THREADS_FAILURE",
  SET_SELECTED_USER_THREAD_ID = "@CHAT/SET_SELECTED_USER_THREAD_ID",
  DELETE_USER_THREAD = "@CHAT/DELETE_USER_THREAD",
  RENAME_USER_THREAD = "@CHAT/RENAME_USER_THREAD",
  UPDATE_THREAD_PINNED = "@CHAT/UPDATE_THREAD_PINNED",
  UPDATE_THREAD_SHARED = "@CHAT/UPDATE_THREAD_SHARED",
  UPDATE_THREAD_NAME = "@CHAT/UPDATE_THREAD_NAME",
  UPSERT_USER_THREAD = "@CHAT/UPSERT_USER_THREAD",
  HANDLE_STATUS_UPDATE = "@CHAT/HANDLE_STATUS_UPDATE",
  MERGE_HITL_EDITED_ARGS = "@CHAT/MERGE_HITL_EDITED_ARGS",
  START_THINKING = "@CHAT/START_THINKING",
  UPDATE_THINKING_STEP = "@CHAT/UPDATE_THINKING_STEP",
  END_THINKING = "@CHAT/END_THINKING",
  SET_PLAN_PROGRESS = "@CHAT/SET_PLAN_PROGRESS",
  CLEAR_PLAN_PROGRESS = "@CHAT/CLEAR_PLAN_PROGRESS",
  SET_REMOTE_SESSION = "@CHAT/SET_REMOTE_SESSION",
  ADD_SSH_EVENT = "@CHAT/ADD_SSH_EVENT",
  CLEAR_REMOTE_SESSION = "@CHAT/CLEAR_REMOTE_SESSION",
  APPLY_COMPUTER_USE_EVENT = "@CHAT/APPLY_COMPUTER_USE_EVENT",
  SET_COMPUTER_USE_RUNS = "@CHAT/SET_COMPUTER_USE_RUNS",

  // Integration Action Types
  INTEGRATION_LOADING = "@INTEGRATION/INTEGRATION_LOADING",
  INTEGRATION_ERROR = "@INTEGRATION/INTEGRATION_ERROR",

  // Customer Management
  GET_CUSTOMERS_REQUEST = "@INTEGRATION/GET_CUSTOMERS_REQUEST",
  GET_CUSTOMERS = "@INTEGRATION/GET_CUSTOMERS",
  GET_CUSTOMERS_FAILURE = "@INTEGRATION/GET_CUSTOMERS_FAILURE",
  GET_MSPS = "@INTEGRATION/GET_MSPS",
  GET_CUSTOMER_BY_ID = "@INTEGRATION/GET_CUSTOMER_BY_ID",
  GET_MSP_BY_ID = "@INTEGRATION/GET_MSP_BY_ID",
  CREATE_CUSTOMER = "@INTEGRATION/CREATE_CUSTOMER",
  UPDATE_CUSTOMER = "@INTEGRATION/UPDATE_CUSTOMER",
  DELETE_CUSTOMER = "@INTEGRATION/DELETE_CUSTOMER",

  // User Management
  GET_USERS_BY_MSP_ID = "@INTEGRATION/GET_USERS_BY_MSP_ID",
  CREATE_USER = "@INTEGRATION/CREATE_USER",
  UPDATE_USER = "@INTEGRATION/UPDATE_USER",
  DELETE_USER = "@INTEGRATION/DELETE_USER",

  // Application Management
  CLEAR_APPLICATIONS = "@INTEGRATION/CLEAR_APPLICATIONS",
  GET_APPLICATIONS_BY_CUSTOMER_REQUEST = "@INTEGRATION/GET_APPLICATIONS_BY_CUSTOMER_REQUEST",
  GET_APPLICATIONS_BY_CUSTOMER = "@INTEGRATION/GET_APPLICATIONS_BY_CUSTOMER",
  GET_APPLICATIONS_BY_CUSTOMER_FAILURE = "@INTEGRATION/GET_APPLICATIONS_BY_CUSTOMER_FAILURE",
  GET_APPLICATION_DETAILS = "@INTEGRATION/GET_APPLICATION_DETAILS",
  GET_APPLICATION_PERMISSIONS = "@INTEGRATION/GET_APPLICATION_PERMISSIONS",
  UPDATE_APPLICATION_STATE = "@INTEGRATION/UPDATE_APPLICATION_STATE",
  UPDATE_PLATFORM_STATE = "@INTEGRATION/UPDATE_PLATFORM_STATE",
  UPDATE_APPLICATION_CONFIG = "@INTEGRATION/UPDATE_APPLICATION_CONFIG",
  ADD_APPLICATION_TO_CUSTOMER = "@INTEGRATION/ADD_APPLICATION_TO_CUSTOMER",
  REMOVE_APPLICATION_FROM_CUSTOMER = "@INTEGRATION/REMOVE_APPLICATION_FROM_CUSTOMER",

  // Action Management
  GET_APPLICATION_ACTIONS_REQUEST = "@INTEGRATION/GET_APPLICATION_ACTIONS_REQUEST",
  GET_APPLICATION_ACTIONS = "@INTEGRATION/GET_APPLICATION_ACTIONS",
  GET_APPLICATION_ACTIONS_FAILURE = "@INTEGRATION/GET_APPLICATION_ACTIONS_FAILURE",
  CLEAR_APPLICATION_ACTIONS = "@INTEGRATION/CLEAR_APPLICATION_ACTIONS",
  UPDATE_ACTION_PERMISSION = "@INTEGRATION/UPDATE_ACTION_PERMISSION",
  UPDATE_ACTION_CONFIG = "@INTEGRATION/UPDATE_ACTION_CONFIG",

  // Platform Management
  GET_PLATFORMS_REQUEST = "@INTEGRATION/GET_PLATFORMS_REQUEST",
  GET_PLATFORMS = "@INTEGRATION/GET_PLATFORMS",
  GET_PLATFORMS_FAILURE = "@INTEGRATION/GET_PLATFORMS_FAILURE",
  GET_PLATFORM_ACTIONS_REQUEST = "@INTEGRATION/GET_PLATFORM_ACTIONS_REQUEST",
  GET_PLATFORM_ACTIONS = "@INTEGRATION/GET_PLATFORM_ACTIONS",
  GET_PLATFORM_ACTIONS_FAILURE = "@INTEGRATION/GET_PLATFORM_ACTIONS_FAILURE",
  UPDATE_PLATFORM_ACTION_PERMISSION = "@INTEGRATION/UPDATE_PLATFORM_ACTION_PERMISSION",
  UPDATE_PLATFORM_CONFIG = "@INTEGRATION/UPDATE_PLATFORM_CONFIG",
  CREATE_PLATFORM = "@INTEGRATION/CREATE_PLATFORM",
  CREATE_APPLICATION = "@INTEGRATION/CREATE_APPLICATION",
  GET_AVAILABLE_PLATFORMS = "@INTEGRATION/GET_AVAILABLE_PLATFORMS",
  GET_AVAILABLE_APPLICATIONS = "@INTEGRATION/GET_AVAILABLE_APPLICATIONS",

  // Statistics and Audit
  GET_APPLICATION_STATS = "@INTEGRATION/GET_APPLICATION_STATS",
  GET_PLATFORM_INTEGRATION_STATUS = "@INTEGRATION/GET_PLATFORM_INTEGRATION_STATUS",
  GET_ACTION_AUDIT_LOG = "@INTEGRATION/GET_ACTION_AUDIT_LOG",

  // Application Configuration Management
  TEST_APPLICATION_CONFIGURATION = "@INTEGRATION/TEST_APPLICATION_CONFIGURATION",
  SET_TEST_RESULT = "@INTEGRATION/SET_TEST_RESULT",

  CLEAR_CHAT = "@CHAT/CLEAR_CHAT",
  CLEAR_MESSAGES = "@CHAT/CLEAR_MESSAGES",

  GET_GUIDES = "@GUIDE/GET_GUIDES",
  GET_GUIDE_BY_ID = "@GUIDE/GET_GUIDE_BY_ID",
  ADD_GUIDE = "@GUIDE/ADD_GUIDE",
  GUIDE_LOADING = "@GUIDE/LOADING",
  GUIDE_ERROR = "@GUIDE/ERROR",
  UPDATE_GUIDE = "@GUIDE/UPDATE_GUIDE",
  DELETE_GUIDE = "@GUIDE/DELETE_GUIDE",
  SET_GUIDE_CUSTOMER_SELECTION = "@GUIDE/SET_GUIDE_CUSTOMER_SELECTION",

  GET_DOCS = "@DOC/GET_DOCS",
  GET_DOC_BY_ID = "@DOC/GET_DOC_BY_ID",
  ADD_DOC = "@DOC/ADD_DOC",
  DOC_LOADING = "@DOC/LOADING",
  DOC_ERROR = "@DOC/ERROR",
  UPDATE_DOC = "@DOC/UPDATE_DOC",
  DELETE_DOC = "@DOC/DELETE_DOC",
  SET_DOC_CUSTOMER_SELECTION = "@DOC/SET_DOC_CUSTOMER_SELECTION",
  CREATE_USER_THREAD = "@CHAT/CREATE_USER_THREAD",
  GET_USER_THREAD = "@CHAT/GET_USER_THREAD",
  GET_CUSTOMERS_BY_MSP_ID = "@INTEGRATION/GET_CUSTOMERS_BY_MSP_ID",

  // Observer Action Types
  OBSERVER_SET_LOADING = "OBSERVER_SET_LOADING",
  OBSERVER_SET_ERROR = "OBSERVER_SET_ERROR",
  OBSERVER_SET_THREADS = "OBSERVER_SET_THREADS",
  OBSERVER_SET_SELECTED_THREAD = "OBSERVER_SET_SELECTED_THREAD",
  OBSERVER_SET_SELECTED_MESSAGES = "OBSERVER_SET_SELECTED_MESSAGES",
  OBSERVER_SET_FILTERS = "OBSERVER_SET_FILTERS",
  OBSERVER_SET_SORT = "OBSERVER_SET_SORT",
  OBSERVER_SET_PAGINATION = "OBSERVER_SET_PAGINATION",
  OBSERVER_SET_STATS = "OBSERVER_SET_STATS",
  OBSERVER_TOGGLE_FILTERS = "OBSERVER_TOGGLE_FILTERS",
  OBSERVER_RESET_FILTERS = "OBSERVER_RESET_FILTERS",
}

export const FETCH_PILLS_REQUEST = "FETCH_PILLS_REQUEST";
export const FETCH_PILLS_SUCCESS = "FETCH_PILLS_SUCCESS";
export const FETCH_PILLS_FAILURE = "FETCH_PILLS_FAILURE";
export const SET_PILLS_KEYWORD = "SET_PILLS_KEYWORD";

export const FETCH_SUGGESTIONS_REQUEST = "FETCH_SUGGESTIONS_REQUEST";
export const FETCH_SUGGESTIONS_SUCCESS = "FETCH_SUGGESTIONS_SUCCESS";
export const FETCH_SUGGESTIONS_FAILURE = "FETCH_SUGGESTIONS_FAILURE";
